import GoalsTour from './GoalsTour';

export default GoalsTour;
